<template>
    <div>
        <ul id="treeDiv" class="ztree" style="min-width:200px;margin-top:5px;margin-left:-10px">
            <z-collapse-item
                    :selectNode="selectNode"
                    :collapseData="collapseData"
                    @setSelectNodeLink="setSelectNodeLink"
                    @setUnExpand="setUnExpand"
                    @changeLength="changeLength"
                    @changeIsExpand="changeIsExpand">

            </z-collapse-item>
        </ul>
    </div>
</template>

<script>
    import ZCollapseItem from './CollapseItem.vue'
    export default {
        name: 'ZCollapseOrgAndDevice',
        props:["collapseData"],
        data () {
            return {
                selectNode: {link:null}
            }
        },
        components:{
            ZCollapseItem
        },
        methods:{
            setSelectNodeLink(selectNodeLink){
                this.selectNode.link = selectNodeLink
            },
            setUnExpand(node){
                if(this.selectNode.link == node.link || (this.selectNode.link && this.selectNode.link.indexOf(node.link) != -1)){
                    this.selectNode.link = null
                }

                if(this.selectNode.link == null){
                    if (node.pid) {
                        let currentNode = this.getNodeById(node.pid,this.collapseData)
                        currentNode.length = 5
                        this.selectNode.link = currentNode.link
                    }
                }
            },
            changeIsExpand(orgId,isExpand){
                this.$emit("changeIsExpand",orgId,isExpand)
            },
            changeLength(orgId,length){
                this.$emit("changeLength",orgId,length)
            },
            getNodeById(nodeId,data){
                for(let i = 0 ; i < data.length ; i ++){
                    if(nodeId == data[i].id){
                        return data[i]
                    }

                    if(data[i].children){
                        let node =  this.getNodeById(nodeId,data[i].children);
                        if(node){
                            return node
                        }
                    }
                }
                return null;
            }
        },
        mounted () {
          // console.log(this.selectNode)
          // console.log(this.collapseData)
        }
    }
</script>